import { useMemo } from 'react';
import Organization from 'infrastructure/Organization';
import { ProgressBar } from 'shared_ui_components';
import { useModuleAssessmentStore } from './ModuleAssessment.store';
import classes from './ModuleAssessmentCard.module.css';
import takeIcon from 'assets/icons/sparkle.svg';
import { useSalesRepView } from 'features/salesRepView/SalesRepView.hook';

/** Show the score,take quiz button and retake button to the rep for module based assessment  */
const ModuleAssessmentCardButton = ({ module, isEnabled, styles, setUserAssesmentDialog = null, isRepView = false }) => {
  const { module_assessment_rating_percentages: score = 0 } = module || {};  
  // Show components logic
  const showTakeQuiz = useMemo(() => {
    const module_completed = module?.is_completed;
    const not_started = module?.module_assessment_status === STATUS.NOT_STARTED;
    const module_has_assessment = module?.module_assessment_enable;

    return isEnabled && module_has_assessment && not_started && module_completed;
  }, [module, isEnabled]);

  const showRetakeQuiz = useMemo(() => {
    const module_completed = module?.is_completed;
    const module_has_assessment = module?.module_assessment_enable;
    if (showTakeQuiz) return false;
    return isEnabled && module_has_assessment && module_completed;
  }, [isEnabled, module?.is_completed, module?.module_assessment_enable, showTakeQuiz]);

  const showScore = useMemo(() => {
    if (!isEnabled) return false;
    const module_has_assessment = module?.module_assessment_enable;
    const status = [STATUS.FAILED, STATUS.PASSED].includes(module?.module_assessment_status);
    return module_has_assessment && status;
  }, [module, isEnabled]);

  const showProgressBar = useMemo(() => {
    /** Show the existing progress bar when no other module based assessment component is shown */
    if (showTakeQuiz || showRetakeQuiz || showScore) return false;
    return Boolean(module?.completed_count);
  }, [module, showRetakeQuiz, showScore, showTakeQuiz]);

  // Click handlers
  const { setModuleIdToViewResults, setModuleIdToAnswer, setModuleName } = useModuleAssessmentStore(
    (state) => state
  );

  const onScoreClick = (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (!showScore) return;
    setModuleIdToViewResults(module?.uuid);
    setModuleName(module?.title);
  };

  const onTakeQuizClick = (e) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (showTakeQuiz || showRetakeQuiz) {
      setModuleIdToAnswer(module?.uuid);
      setModuleName(module?.title);
      setUserAssesmentDialog(true);
    }
  };

  const { isActive } = useSalesRepView();

  if (Organization?.isRep() ? false : !isActive) return null;
  if(isRepView && showProgressBar) return null 
  else if (showProgressBar)
    return (
      <div className={`${styles.progressBlk} ${classes.container}`}>
        <ProgressBar
          max={100}
          value={(module.completed_count / module.content_count) * 100}
          className={styles.stepProgress + ' stepProgress'}
        />
      </div>
    );

  return (
    <div className={classes.container}>
      {showScore && (
        <button
          className={
            module?.module_assessment_status === STATUS.PASSED ? classes?.success : classes?.failed
          }
          onClick={onScoreClick}
        >
          Score {score}%
        </button>
      )}
      {showTakeQuiz && (
        <button className={classes.button} onClick={onTakeQuizClick}>
          <img src={takeIcon} alt="" />
          <span>Take quiz</span>
        </button>
      )}
      {showRetakeQuiz && (
        <button className={classes.button} onClick={onTakeQuizClick}>
          <svg
            width="21"
            height="18"
            viewBox="0 0 21 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 9C0 11.3869 0.948211 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18C11.39 18 13.68 17.06 15.4 15.4L13.9 13.9C13.2704 14.5667 12.5107 15.0971 11.6679 15.4583C10.825 15.8196 9.91698 16.0039 9 16C2.76 16 -0.36 8.46 4.05 4.05C8.46 -0.36 16 2.77 16 9H13L17 13H17.1L21 9H18C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948211 11.3869 0 9 0C6.61305 0 4.32387 0.948211 2.63604 2.63604C0.948211 4.32387 0 6.61305 0 9Z"
              fill="#0494FD"
            />
          </svg>
          <span>Retake</span>
        </button>
      )}
    </div>
  );
};

const STATUS = {
  FAILED: -1,
  NOT_STARTED: 0,
  PASSED: 1,
};

export default ModuleAssessmentCardButton;
